/** Material-style inline icon paths from the design handoff (14–20px). */

export function PhoneIcon({ size = 14, fill = '#141414' }: { size?: number; fill?: string }) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill={fill} aria-hidden="true">
			<path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
		</svg>
	)
}

export function MicIcon({ size = 20, fill = '#fff' }: { size?: number; fill?: string }) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill={fill} aria-hidden="true">
			<path d="M12 14a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v5a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.92V21h2v-3.08A7 7 0 0 0 19 11h-2z" />
		</svg>
	)
}

/* The entrance set. These inherit `currentColor` instead of carrying a hex,
   because the same glyph appears on the light promise coin and inside the
   dark „Inkább írok" button. */

export function PenIcon({ size = 17 }: { size?: number }) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
			<path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
		</svg>
	)
}

export function BatteryIcon({ size = 17 }: { size?: number }) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
			<path d="M20 8h-1V6h-4v2h-6V6H5v2H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-8.5 8.5v-2.75H9l3.5-5.25v3.75H15l-3.5 4.25z" />
		</svg>
	)
}

export function CalendarIcon({ size = 17 }: { size?: number }) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
			<path d="M16 1v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1V1h-2zm3 18H5V8h14v11zm-2-9h-5v5h5v-5z" />
		</svg>
	)
}

export function PinIcon({ size = 17 }: { size?: number }) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
			<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
		</svg>
	)
}
